<header class="inset-x-0 top-0 z-10 border-b border-gray-900/10">
    <div class="mx-auto flex w-full max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 py-2 h-16">
        <div class="flex items-center gap-x-6">
            <img
                class="h-7 w-auto shrink-0"
                src="/assets/logo/blue_black/ares_logo_blue_black@2x.png"
                alt="ARES"
                height="158"
                width="458"
            >

            @if (!isAgent()) {
                <app-location-switcher class="w-56 hidden md:block" />
            }
        </div>

        <!-- Desktop navigation -->
        <nav class="hidden md:flex shrink-0 gap-x-6 lg:gap-x-11 text-sm font-normal leading-6 text-gray-700 pl-6">
            @for (item of navItems(); track item.label) {
                <a
                    class="hover:underline whitespace-nowrap inline-flex items-center gap-x-1.5"
                    [routerLink]="item.href"
                    routerLinkActive="!font-semibold !border-blue-500 !text-gray-900"
                >
                    <app-icon [icon]="item.icon" size="nav" />
                    {{ item.label }}
                </a>
            }
        </nav>

        <!-- pl-* keeps the bell clear of the last nav item; without it justify-between lets them touch -->
        <div class="flex items-center justify-end gap-x-4 shrink-0 pl-4 lg:pl-8">
            @if (isAuthenticated()) {
                @if (isAdminOrOwner()) {
                    <app-notification-bell class="hidden md:block" />
                }

                <a class="-m-1.5 p-1.5 hidden md:block">
                    <app-avatar
                        size="normal"
                        [employee]="avatarProfile()"
                        [appDropdown]="dropdownMenu()"
                        appDropdownAlign="right"
                    />
                </a>
            } @else {
                <button
                    type="button"
                    (click)="login()"
                    class="text-sm font-semibold leading-6 text-gray-900 hover:text-blue-600 hidden md:block"
                >
                    Inloggen
                </button>
            }

            <!-- Mobile menu button -->
            <button
                type="button"
                (click)="mobileMenuOpen.set(!mobileMenuOpen())"
                class="md:hidden -m-2 p-2 text-gray-700 hover:text-gray-900"
            >
                <ng-icon
                    [name]="mobileMenuOpen() ? 'heroXMark' : 'heroBars3'"
                    size="1.5em"
                />
            </button>
        </div>
    </div>

    <!-- Mobile menu dropdown -->
    @if (mobileMenuOpen()) {
        <div class="md:hidden border-t border-gray-200 bg-white">
            <!-- Establishment select on mobile -->
            @if (!isAgent()) {
                <div class="px-4 py-3 border-b border-gray-100">
                    <app-location-switcher class="w-full" />
                </div>
            }

            <!-- Mobile navigation links -->
            <nav class="px-4 py-2">
                @for (item of navItems(); track item.label) {
                    <a
                        (click)="mobileMenuOpen.set(false)"
                        [routerLink]="item.href"
                        routerLinkActive="bg-blue-50 text-blue-600 font-semibold"
                        class="flex items-center gap-x-2.5 px-3 py-2.5 text-base text-gray-700 hover:bg-gray-50 rounded-lg"
                    >
                        <app-icon [icon]="item.icon" size="nav" />
                        {{ item.label }}
                    </a>
                }
            </nav>

            <!-- Mobile user section -->
            <div class="border-t border-gray-200 px-4 py-3">
                @if (isAuthenticated()) {
                    <div class="flex items-center gap-3 mb-3">
                        <app-avatar
                            size="normal"
                            [employee]="avatarProfile()"
                        />
                        <div class="text-sm font-medium text-gray-900">
                            {{ avatarProfile().firstName }} {{ avatarProfile().lastName }}
                        </div>
                    </div>
                    <div class="space-y-1">
                        @if (!isAgent()) {
                            <a
                                (click)="mobileMenuOpen.set(false)"
                                [routerLink]="['settings']"
                                class="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg"
                            >
                                <ng-icon name="heroCog6Tooth" size="1.1em" class="mr-2" />
                                Instellingen
                            </a>
                        }
                        <button
                            (click)="logout(); mobileMenuOpen.set(false)"
                            class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg"
                        >
                            <ng-icon name="heroArrowRightOnRectangle" size="1.1em" class="mr-2" />
                            Uitloggen
                        </button>
                    </div>
                } @else {
                    <button
                        type="button"
                        (click)="login(); mobileMenuOpen.set(false)"
                        class="w-full px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                    >
                        Inloggen
                    </button>
                }
            </div>
        </div>
    }

    <div class="border-t">
        <!-- Breadcrumbs + desktop sub-nav row -->
        <div class="flex max-w-7xl mx-auto overflow-x-auto">
            <pandora-breadcrumbs
                [items]="breadcrumbs()"
            />
            @if (submenu(); as submenu) {
                <div class="hidden lg:flex">
                    <app-sub-header [items]="submenu" />
                </div>
            }
        </div>
        <!-- Mobile sub-nav tabs row (own row, always visible) -->
        @if (submenu()?.length) {
            <div class="lg:hidden border-t border-gray-100 bg-white overflow-x-auto">
                <div class="flex max-w-7xl mx-auto px-4">
                    @for (item of submenu()!; track item.name) {
                        <a
                            [routerLink]="item.href"
                            routerLinkActive="!font-semibold !border-blue-500 !text-gray-900"
                            class="inline-flex items-center border-b-2 border-transparent px-3 py-2 text-sm font-normal text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap"
                        >
                            {{ item.name }}
                        </a>
                    }
                </div>
            </div>
        }
    </div>
</header>
